import { Capability } from '__types__';
import {
  Clapperboard,
  FileText,
  Palette,
  PlaneTakeoff,
  Settings
} from 'lucide-react';
import type { EnterpriseTeamSettingsRoutes } from 'v5/core/routing/appRouting';
import { NavLink } from 'v5/platform/react-router';
import { MenuItem } from 'v5/patterns/sidebar/Menu';
import { EnterpriseTeam } from 'v5/api/enterprise/enterprise.api';
import { ifCan } from 'v5/platform/react/ifCan';
import { AccessQuery } from 'v5/services/front/AccessService/AccessService';

/** Team settings — scoped items only; workspace menu holds the rest. */
export function renderEnterpriseTeamSettingsItems(
  _team: EnterpriseTeam,
  settings: EnterpriseTeamSettingsRoutes,
  can: (query: AccessQuery) => boolean,
  level = 2
) {
  const routes = settings;

  return ifCan(can)
    .render(can => (
      <>
        {can({ action: Capability.CONFIGURE_WORKSPACE }) && (
          <NavLink to={routes.publicProfile()}>
            <MenuItem level={level} icon={<Settings className="size-4" />}>
              General
            </MenuItem>
          </NavLink>
        )}
        {can({ action: Capability.CONFIGURE_WORKSPACE }) && (
          <NavLink to={routes.theming()}>
            <MenuItem level={level} icon={<Palette className="size-4" />}>
              Theming
            </MenuItem>
          </NavLink>
        )}
        {can({ action: Capability.CONFIGURE_PRODUCTION_TEMPLATES }) && (
          <NavLink to={routes.productionTemplates()}>
            <MenuItem level={level} icon={<Clapperboard className="size-4" />}>
              Production templates
            </MenuItem>
          </NavLink>
        )}
        {can({ action: Capability.CONFIGURE_CALLSHEET_TEMPLATES }) && (
          <NavLink to={routes.callsheetTemplates()}>
            <MenuItem level={level} icon={<FileText className="size-4" />}>
              Callsheet templates
            </MenuItem>
          </NavLink>
        )}
        {can({ action: Capability.CONFIGURE_CUSTOM_NIKE_ARRIVAL_BOARD }) && (
          <NavLink to={routes.arrivalBoard()}>
            <MenuItem level={level} icon={<PlaneTakeoff className="size-4" />}>
              Arrival board
            </MenuItem>
          </NavLink>
        )}
      </>
    ))
    .otherwise(null);
}
